<div class="row mt-2 no-gutters">
	<div class="col">
		<small *ngIf="accountCategory == 'DEALER'" (click)="showSearchResult = false"><a [routerLink]="['/dealer']"
				class="text-secondary">Admin
				Console</a>
			/<a [routerLink]="['/business-entity']" (click)="closeClicked()" class="text-secondary"> Business
				Entity</a>
			<a *ngIf="isViewScreen" [routerLink]="['/business-entity']" (click)="isViewScreen = false;"
				class="text-secondary"> / {{selectedBusinessEntity.accountName}}</a></small>
	</div>
</div>

<div *ngIf="!isViewScreen" class="row mt-3 no-gutters">
	<div class="col-12 table-responsive">
		<table class="table table-striped tbl-scrollable">
			<thead class="thead-light">
				<tr>
					<th scope="col" width="12%" class="pl-0 pr-0">&nbsp;</th>
					<th scope="col" width="20%">Account Name</th>
					<th scope="col" width="20%">Account Type</th>
					<th scope="col" width="16%">Payment Type</th>
					<th scope="col" width="16%">Balance (USD)</th>
					<th scope="col" width="16%">Status</th>
				</tr>
			</thead>
			<tbody class="max-height-75">
				<ng-container *ngIf="businessEntities && businessEntities.length > 0">
					<tr class="cursor-pointer" *ngFor="let businessEntity of businessEntities; let i = index"
						(click)="navigateToDetailPage(businessEntity)">
						<td width="12%" class="text-center pr-0 pl-0">
							<img class="business-account-logo" src="assets/images/placeholder.png" *ngIf="!businessEntity.logo">
							<img class="business-account-logo" [src]="businessEntity.logo" *ngIf="businessEntity.logo">
						</td>
						<td width="20%">{{businessEntity.accountName}}</td>
						<td width="20%">{{businessEntity.appAccountType | customText}}</td>
						<td width="16%">{{businessEntity.paymentType}}</td>
						<td width="16%">{{businessEntity.accountBalance}}</td>
						<td width="16%">
							<i *ngIf="businessEntity.status=='ACTIVE'" class="fa fa-check-circle text-success" aria-hidden="true"></i>
							<i *ngIf="businessEntity.status=='INACTIVE' || businessEntity.status=='SUSPENDED'"
								class="fa fa-exclamation-circle text-danger" aria-hidden="true"></i>
							<i *ngIf="businessEntity.status=='PENDING'" class="fa fa-minus-circle text-warning"
								aria-hidden="true"></i>
							<i *ngIf="businessEntity.status=='ENABLED'" class="fa fa-minus-circle text-primary"
								aria-hidden="true"></i>
							{{businessEntity.status | customText}}
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
</div>

<div *ngIf="isViewScreen" class="mt-3">
	<!-- <div class="row pt-2 no-gutters">
		<div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 text-left">
			<button class="btn btn-transparent font-nissan-brand-w01-light" style="padding-left: unset;"
				[routerLink]="['/invoices']">INVOICES&nbsp;<span><i
						class="fas fa-chevron-right"></i></span></button>
		</div>
	</div> -->

	<div class="row pt-2 bg-light no-gutters mx-0 pb-1">
		<div class="col-sm table-responsive px-0">
			<table class="table table-borderless mb-0">
				<tbody>
					<tr>
						<td width="40%" class="p-0 w-break">
							<div class="row">
								<div class="my-auto align-center pl-4 account-logo-padding">
									<img class="business-account-detail-logo" *ngIf="selectedBusinessEntity.logo"
										src="{{selectedBusinessEntity.logo}}" alt="{{selectedBusinessEntity.accountName}}" />
									<img class="business-account-detail-logo" *ngIf="!selectedBusinessEntity.logo"
										src="assets/images/placeholder.png" alt="alt" />
								</div>
								<div class="pl-3 account-name-padding">
									<div class="font14-700 cursor-pointer">{{selectedBusinessEntity.accountName}}
										&nbsp;<span
											[ngClass]="{'ACTIVE':'badge-success', 'INACTIVE':'badge-danger', 'SUSPENDED':'badge-danger', 'PENDING':'badge-warning', 'ENABLED':'badge-primary'}[selectedBusinessEntity.status]"
											class="badge badge-pill badge-400"> {{selectedBusinessEntity.status |
											customText}}</span>
									</div>
									<div class="font13-400 d-sm-table-cell">
										{{selectedBusinessEntity.contactPoints.addresses[0].street}}
										<br>
										{{selectedBusinessEntity.contactPoints.addresses[0].city}},
										{{selectedBusinessEntity.contactPoints.addresses[0].state}},
										{{selectedBusinessEntity.contactPoints.addresses[0].postalCode}}
									</div>
								</div>
							</div>
						</td>
						<td width="15%" class="px-0 d-none d-sm-table-cell">
							<div class="text-center cursor-pointer">
								<div class="font13-400">Payment Type</div>
								<div class="font14-600 mt-1">{{selectedBusinessEntity.paymentType}}</div>
							</div>
						</td>
						<td width="18%" class="px-0 d-none d-sm-table-cell">
							<div class="cursor-pointer text-center">
								<div class="font13-400">Account Balance (USD)</div>
								<div class="font14-600 mt-1">
									{{selectedBusinessEntity.accountBalance | number : '1.2-2'}}</div>
							</div>
						</td>

						<td width="17%" class="pl-0 d-none d-sm-table-cell">
							<div class="text-center">
								<div class="font13-400">Customer Id</div>
								<div class="font14-600 mt-1">{{selectedBusinessEntity.oemCustomerId}}</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="row mt-3 border-top border-bottom no-gutters">
		<div class="col-12 mt-2 mb-2 heading font-nissan-brand-w01-light lh-35">Invoices</div>
		<app-be-invoices [invoices]="invoices" (selectedInvoiceEmitter)="onInvoiceSelected($event)"
			(onPaymentStatusEmitter)="getInvoices()" #beInvoiceListComponent></app-be-invoices>
			
		<!-- <div *ngIf="invoices && invoices.length > 0" class="col-12 table-responsive no-gutter hide-x-scroll">
			<table class="table table-striped tbl-scrollable">
				<thead class="thead-light cursor-pointer">
					<tr>
						<th width="15%" scope="col">Invoice No</th>
						<th width="25%" scope="col">Account</th>
						<th width="15%" scope="col">Amount <span
								*ngIf="invoices && invoices.length > 0">({{invoices[0].invoiceSummary.currency}})</span></th>
						<th width="15%" scope="col" (click)="onSortByDateClick(columns[3])">Invoice Date
							&nbsp;&nbsp;
							<span *ngIf="tableSelectedSortOptions[0] == columns[3]"><i
									*ngIf="tableSelectedSortOptions[1] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
									*ngIf="tableSelectedSortOptions[1] == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i>
							</span>
						</th>
						<th width="15%" scope="col">Due Date</th>
						<th width="15%" class="text-right" scope="col">Status</th>
					</tr>
				</thead>
				<tbody class="max-height-57">
					<tr class="pointer" *ngFor="let invoice of invoices; let i = index">
						<td width="15%">{{invoice.invoiceNumber}}</td>
						<td width="25%">{{invoice.customerInfo.accountInfo.name}}</td>
						<td width="15%">{{invoice.invoiceSummary.total | number : '1.2-2'}}</td>
						<td width="15%">{{invoice.invoiceDate | date: 'MM/dd/yyyy': 'Z'}}</td>
						<td width="15%">{{invoice.invoiceSummary.dueDate | date: 'MM/dd/yyyy': 'Z'}}</td>
						<td width="15%" class="text-right">
							<span>{{invoice.invoiceStatus | customText}}</span><br>
							<span
								*ngIf="invoice.invoiceStatus != invoiceStatusList[2] && invoice.paymentStatus && invoice.paymentStatus=='PROCESSING'"><small>(Payment
									Processing)</small></span>
						</td>
					</tr>
				</tbody>
			</table>
		</div> -->
	</div>

</div>